import { ACTION_TYPES } from './action_types';
import { defaultPeriscopeState } from '../read/state';
import { READ_ACTION_TYPES } from '../read/action_types';
import { ReadPeriscopeAction } from '../read/actions';
import { REMOVE_ACTION_TYPES } from '../remove/action_types';
import { removePeriscope } from '../remove/reducer';
import { RemovePeriscopeAction } from '../remove/actions';

import { ApplicationActionType, ResetApplication } from '../../../application/actions';
import { PeriscopeCard, PeriscopeState, UpdatePeriscopeSync } from '@sonar-software/sonar-ts-types';
import { take, takeRight, updateAt } from '@sonar-software/sonar-ts-lib';
import { UpdateAnalysisPeriscopeAction, UpdatePeriscopeAction, UpdatePeriscopeInfoAction } from './actions';

function buildNewPeriscopeArray(cards: PeriscopeCard[], data: UpdatePeriscopeSync): PeriscopeCard[] {
	const { limit = 3, periscopeIndex, openLeft = false, ...rest } = data;

	const newPeriscope: PeriscopeCard = {
		...rest
	};

	if (openLeft && periscopeIndex === 1) {
		return take([ newPeriscope, ...cards ], limit);
	}

	return takeRight([ ...cards.slice(0, periscopeIndex), newPeriscope ], limit);
}

export type PeriscopeAction =
	| UpdatePeriscopeAction
	| RemovePeriscopeAction
	| ReadPeriscopeAction
	| UpdatePeriscopeInfoAction
	| UpdateAnalysisPeriscopeAction;

export function periscopeReducers(
	state: PeriscopeState = defaultPeriscopeState,
	action: ResetApplication | PeriscopeAction
): PeriscopeState {
	const { type } = action;

	switch (type) {
	case REMOVE_ACTION_TYPES.REMOVE_PERISCOPE:
		return removePeriscope((action as RemovePeriscopeAction).data, state);
	case READ_ACTION_TYPES.RESET_PERISCOPE:
		return defaultPeriscopeState;
	case READ_ACTION_TYPES.RESET_ANALYSIS_PERISCOPE:
		return {
			...defaultPeriscopeState,
			cards: [
				...state.cards
			]
		};
	case ACTION_TYPES.UPDATE_PERISCOPE:
		return {
			...defaultPeriscopeState,
			cards: buildNewPeriscopeArray(state.cards, (action as UpdatePeriscopeAction).data)
		};
	case ACTION_TYPES.UPDATE_PERISCOPE_INFO:
		const { periscopeIndex, ...rest } = action.data;

		if (state.analysisTarget) {
			return {
				analysisTarget: {
					...state.analysisTarget,
					...rest
				},
				cards: [
					...state.cards
				]
			};
		}

		return {
			...defaultPeriscopeState,
			cards: updateAt(state.cards, action.data.periscopeIndex, (card) => ({
				...card,
				...rest
			}))
		};
	case ACTION_TYPES.UPDATE_ANALYSIS_PERISCOPE:
		return {
			...state,
			analysisTarget: action.data
		};
	case ApplicationActionType.Reset:
		return {
			...defaultPeriscopeState
		};
	default:
		return state;
	}
}
